import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3696522302/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
